import * as BFText from './skins/BF/text';
import * as SNText from './skins/SN/text';
import * as MTText from './skins/MT/text';

const textModules = {
  BF: BFText,
  SN: SNText,
  MT: MTText,
};

const siteCode = process.env.REACT_APP_SITE_CODE;

if (!textModules[siteCode]) {
  throw new Error(`Unsupported site code for text module: ${siteCode}`);
}

const textData = textModules[siteCode];

const { default: t, text } = textData;

export { text };
export default t;